import { get } from 'svelte/store';
import { backend_url, access_token } from './store';
import { storeEvents, storeEventsError } from './event';
import { authentication } from './api';
/**
 * getEvents
 * /events/ - GET
 */
export async function getEvents() {
    const apiUrl = get(backend_url) + "v1/events/";
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeEvents.set(data);
        storeEventsError.set("");
        return true;
    })
        .catch((error) => {
        storeEvents.set([]);
        storeEventsError.set(initError(error));
        return false;
    });
}
/**
 * initError
 * @param errorStatus
 * @returns
 */
function initError(errorStatus) {
    let returnValue = "";
    if (errorStatus == "Error: 400") {
        returnValue = "Missing parameters";
    }
    else if (errorStatus == "Error: 401") {
        returnValue = "Unauthorized";
    }
    else if (errorStatus == "Error: 404") {
        returnValue = "Not found";
    }
    else if (errorStatus == "Error: 422") {
        returnValue = "Unprocessable entity";
    }
    else {
        returnValue = "Error";
    }
    return returnValue;
}
